class CollapsibleText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const elements = this.children;
    if (!elements) return;

    this.btn = this.querySelector('[data-trigger]');
    
    if (this.dataset.setInitialHeight == 'true') {
      this.initialElement = Array.from(this.children).find(element => element.textContent);
      this.initalHeight = `${this.getElementHeight(this.initialElement) + this.getElementHeight(this.btn)}px`;
      this.style.height = this.initalHeight;
    } else {
      this.initalHeight = this.style.height;
    }

    this.fullHeight = `${Array.from(elements).reduce((a, b) => a + this.getElementHeight(b), 0)}px`;

    this.btn.addEventListener('click', () => {
      if (this.style.height == this.initalHeight) {
        this.btn.textContent = window.themeVariables.strings.showLess;
        this.style.height = this.fullHeight;
      } else {
        this.btn.textContent = window.themeVariables.strings.showMore;
        this.style.height = this.initalHeight;
      }
    })
  }

  getElementHeight(element) {
    if (!element.textContent) {
      return 0;
    }
    
    const style = window.getComputedStyle(element);
    
    const offsetHeight = element.offsetHeight;
    
    const marginTop = parseFloat(style.marginTop);
    const marginBottom = parseFloat(style.marginBottom);
    
    return offsetHeight + marginTop + marginBottom;
  }
}

customElements.define('collapsible-text', CollapsibleText);